import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class RecipeDetail {
    constructor() {
        this.recipeTitle = '';
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('#main').removeAttr('tabindex');
        $('.recipe-detail-instructions-ordered-list ol li').attr('tabindex', '0');
        this.recipeTitle = $('.recipe-detail-i-made-this').attr('data-title');
        $(document).on('click', '.recipe-detail-instructions-ordered-list ol li', e => {
            if (e.target.href == null) {
                this.selectInstruction(e);
            }
        });

        $(document).on('keyup', '.recipe-detail-instructions-ordered-list ol li', e => {
            if (e.key === ' ' || e.code === 'Space' || e.keyCode === 32) {
                this.selectInstruction(e);
            }
        });

        $(document).on('keydown', '.recipe-detail-instructions-ordered-list ol li', e => {
            if (e.key === ' ' || e.code === 'Space' || e.keyCode === 32) {
                e.preventDefault();
            }
        });

        $(document).on('click', 'input[type=checkbox][name^=ingredient]', e => {
            let recipe;
            let ingredient;

            recipe = $(e.currentTarget).attr('data-title');
            ingredient = $(e.currentTarget).attr('name');

            if (this.checkCookie(`${recipe}-${ingredient}`)) {
                this.deleteCookie(`${recipe}-${ingredient}`);
            } else {
                this.addProgressCookie(e.currentTarget, 'ingredients');
            }
        });

        $(document).on('click', '.recipe-detail-i-made-this', e => {
            if ($(e.currentTarget).hasClass('processing')) {
                e.preventDefault();
            } else {
                $(e.currentTarget).toggleClass('processing');
                if (!$(e.currentTarget).hasClass('recipe-made')) {
                    this.updateMadeThis(e.currentTarget);
                } else {
                    this.updateMadeThisDelete(e.currentTarget);
                }
            }
        });

        $(document).on('click', '.play-btn', e => {
            let elem = e.currentTarget;

            let video = $(elem).closest('div').find('video');

            $(video).trigger('play');
            $(elem).addClass('d-none');
        });

        $('video').on('play', e => {
            $('.play-btn').addClass('d-none');
        });

        if (this.checkCookie(`${this.recipeTitle}-madethisclicked`)) {
            $('.recipe-detail-i-made-this').addClass('recipe-made');
        }

        Array.from(
            $('.recipe-detail-instructions-ordered-list ol').children()
        ).forEach(li => {
            let recipe;
            let step;

            recipe = $(li).closest('ol').closest('.recipe-detail-instructions-ordered-list').attr('data-title');
            step = (Array.from(
                $(li).parent().children()
            ).indexOf(li)) + 1;

            if (this.checkCookie(`${recipe}-step-${step}`)) {
                $(li).addClass('active');
            }
        });

        Array.from(
            $('input[type=checkbox][name^=ingredient]')
        ).forEach(inp => {
            let recipe;
            let ingredient;

            recipe = $(inp).attr('data-title');
            ingredient = $(inp).attr('name');

            if (this.checkCookie(`${recipe}-${ingredient}`)) {
                $(inp).attr('checked', 'checked');
            }
        });

        $(document).ready(() => {
            const chicoryPairingSlot = document.querySelector('#chicory_pairing_slot');

            if (chicoryPairingSlot) {
                $(chicoryPairingSlot).css('width', 'auto');
                $(chicoryPairingSlot).css('height', 'auto');
                $(chicoryPairingSlot).css('min-width', 'auto');
                $(chicoryPairingSlot).css('min-height', 'auto');
                if ($('#17602').length) {
                    $('#17602').children().last().css('height', 'auto');
                }

                const labelChicoryLinks = () => {
                    Array.from(chicoryPairingSlot.querySelectorAll('a')).forEach(link => {
                        if (!$(link).text().trim() && !link.hasAttribute('aria-label') && !link.hasAttribute('aria-labelledby')) {
                            $(link).attr('aria-label', 'Shop recipe ingredients');
                        }
                    });
                };

                labelChicoryLinks();

                const pairingObserver = new MutationObserver(labelChicoryLinks);
                pairingObserver.observe(chicoryPairingSlot, { childList: true, subtree: true });
            }

            const observer = new MutationObserver((mutaList, observer) => {
                for (const mut of mutaList) {
                    if (mut.type === 'childList') {
                        if ($('.chicory-button')) {
                            $('.chicory-button').css({
                                color: '#156295', border: '2px solid #156295', background: 'none', 'font-family': 'brandon-grotesque, sans-serif', 'font-weight': '900'
                            });
                        }
                        observer.disconnect();
                    }
                }
            });
            const chicoryOrderIngredients = document.querySelector('.chicory-order-ingredients');
            if (chicoryOrderIngredients) {
                observer.observe(chicoryOrderIngredients, { childList: true });
            }
        });
    }

    checkCookie(cookieName) {
        let regex = new RegExp(`^(.*;)?\\s*${cookieName}\\s*=\\s*[^;]+(.*)?$`);
        if (document.cookie.match(regex)) {
            return true;
        } else {
            return false;
        }
    }

    addProgressCookie(elem, type) {
        let recipe;
        let step;
        let ingredient;
        switch (type) {
            case 'instructions':
                recipe = $(elem).closest('ol').closest('.recipe-detail-instructions-ordered-list').attr('data-title');
                step = (Array.from(
                    $(elem).parent().children()
                ).indexOf(elem)) + 1;

                this.createCookie(`${recipe}-step-${step}`, 72);
                break;
            case 'ingredients':
                recipe = $(elem).attr('data-title');
                ingredient = $(elem).attr('name');

                this.createCookie(`${recipe}-${ingredient}`, 72);
                break;
            default:
                break;
        }
    }

    updateMadeThis(elem) {
        let dataURL = `/api/recipedetail/imadethis?nodealiaspath=${window.location.pathname}`;
        $.ajax({
            type: 'GET',
            url: dataURL,
            success: (results) => this.successCallback(results, elem),
            error: (results) => this.errorCallback(results, elem)
        });
    }

    updateMadeThisDelete(elem) {
        let dataURL = `/api/recipedetail/imadethisdelete?nodealiaspath=${window.location.pathname}`;
        $.ajax({
            type: 'GET',
            url: dataURL,
            success: (results) => this.successCallback(results, elem),
            error: (results) => this.errorCallback(results, elem)
        });
    }

    successCallback(r, elem) {
        if (this.checkCookie(`${this.recipeTitle}-madethisclicked`)) {
            this.deleteCookie(`${this.recipeTitle}-madethisclicked`);
            $(elem).removeClass('recipe-made');
        } else {
            this.createCookie(`${this.recipeTitle}-madethisclicked`, 72);
            $(elem).addClass('recipe-made');
        }
        $(elem).toggleClass('processing');
    }

    errorCallback(r) {
        $(elem).toggleClass('processing');
    }

    selectInstruction(e) {
        let recipe;
        let step;

        $(e.currentTarget).toggleClass('active');

        recipe = $(e.currentTarget).closest('ol').closest('.recipe-detail-instructions-ordered-list').attr('data-title');
        step = (Array.from(
            $(e.currentTarget).parent().children()
        ).indexOf(e.currentTarget)) + 1;

        if (this.checkCookie(`${recipe}-step-${step}`)) {
            this.deleteCookie(`${recipe}-step-${step}`);
        } else {
            this.addProgressCookie(e.currentTarget, 'instructions');
        }
    }

    //expires var is time in hours
    createCookie(cookieName, expires = 0, path = '/') {
        let now = new Date();
        let time = now.getTime();
        let expiretime = time + (expires * 60 * 60 * 1000);
        now.setTime(expiretime);
        document.cookie = `${cookieName}=true; expires=${now.toUTCString()}; path=${path}`;
    }

    deleteCookie(cookieName, path = '/') {
        document.cookie = `${cookieName}=true; expires=01 Jan 1970 00:00:00 UTC; path=${path}`;
    }
}

export default RecipeDetail;

$(() => {
    const recipeDetail = new RecipeDetail();
    recipeDetail.init();
});
